import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Observable } from 'rxjs/Observable';
import { SendMoneyDetail, SendMoneySteps, StoreDetails } from '../../models/sendmoney/sendmoney';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { Ng2DeviceService } from "ng2-device-detector";
@Component({
  selector: 'app-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.css']
})
export class StoreDetailsComponent implements OnInit {
  PageFlow: any = {};
  storeDetail: StoreDetails;
  sendMoneyDetail: SendMoneyDetail;
  constructor(
    private router: Router,
    private modal: Modal,
    private countryserv: CountryService,
    private sendMoneyService: SendMoneyService,
    private vcRef: ViewContainerRef,
    private deviceService: Ng2DeviceService,
    public translate: TranslateService
  ) {
    this.storeDetail = new StoreDetails();
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    if (this.sendMoneyDetail.pickupTypeDetails.countryName == undefined || this.sendMoneyDetail.pickupTypeDetails.countryName == '') {
      if (this.PageFlow.Value == 'repeatorder') {
        if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
          this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(['/repeatorderlist']);
        }
      } else {
        this.router.navigate(['/dashboard']);
      }
      return;
    }
  }
  continueStoreClick() {
    if (this.PageFlow.Value == 'repeatorder') {
      if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
        this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
      } else {
        this.router.navigate(['/repeatorderlist']);
      }
      return;
    } else {
      this.sendMoneyService.setModalPopup(SendMoneySteps.Summary);
      this.router.navigate(['/sendmoney']);
      return;
    }
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (this.sendMoneyDetail.isData == true && this.PageFlow.Value == 'sendmoney') {
      let _self=this;
      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        let loading = false;
        modalData.Title = this.translate.instant('Common_lblConfirm');
        modalData.Message = this.translate.instant('SendMoney_navigateConfirmDesc');
        this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(data => {
            if (modalData.next == 'yes') {
              let DeviceDetail = _self.deviceService.getDeviceInfo();
              (<any>window).firebase
                .analytics()
                .logEvent("UnfinishedTransaction", {
                  Screen: "PaymentType",
                  Platform: AppSettings.Platform,
                  Browser: DeviceDetail.browser,
                  OSVersion: DeviceDetail.os_version,
                  AppVersion: AppSettings.Appversion
                });
              observer.next(true);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
          });
        });
      });
    }
    return true;
  }

  ngOnInit() {
    this.sendMoneyService.getStoreDetailData().subscribe(data => {

      this.storeDetail = data;
    });
    if (this.storeDetail.storeName == undefined || this.storeDetail.storeName == '') {
      this.router.navigate(['/dashboard']);
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/store-details/store-details.component.ts